module.exports = __webpack_public_path__ + "img/marca-pautaria-invertida-color.f9f77610.svg";